const listPointsBody = document.querySelector('#FestSchedule').querySelector('div[name=body]');
// import auth from '../tools/storage.js';

const selectTimeZone = document.querySelector('#FestSchedule').querySelector('select[name=listTimeZone]');
export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  getElement(item, index, maxID) {
    let date = this.strToDate(item.timeStart);
    date = new Date(date.getTime() + (selectTimeZone.value * 60 * 60) * 1000);
    let formattedTime = `${date.getHours()}:${date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()}`;

    if (item.timeEnd) {
      let dateEnd = this.strToDate(item.timeEnd);
      dateEnd = new Date(dateEnd.getTime() + (selectTimeZone.value * 60 * 60) * 1000);
      formattedTime += ` <br> ${dateEnd.getHours()}:${dateEnd.getMinutes() < 10 ? `0${dateEnd.getMinutes()}` : dateEnd.getMinutes()}`;
    }
//2021-03-17 04:00:00
    // let timeStart = item.timeStart.substring(11, 16);
    console.log(item);


    let hallName = '';

    if(item.placeName)
      hallName = item.placeName;

    if(item.hname){
      hallName += ' - ';
      hallName += item.hname;
    }

   
    let streamBox = '';
    if(item.stream)
      streamBox = '<div class = "streamBox"></div>';


    let counfFilms = '';
    if(item.programID)
      counfFilms = '<div class = "filmsMetaBox"></div>';

    let nodeData = ` scheduleid = ${item.id} `;
    let classLastRow = '';
    if (parseInt(item.id, 10) == maxID)
      classLastRow = 'maxID';


    

    return `<div class= " schedule_cloud w-100 ${classLastRow}" ${nodeData}> 
              <div class="column schedule_cloud_time w-10 m-0  mt-1 p-1" ${nodeData}>
                ${formattedTime}
              </div>
              <div class="column w-80 m-0 p-1 " ${nodeData}>
                <div class="schedule_cloud_name m-0 p-1 txt-al-left" ${nodeData}>
                  ${item.name}
                </div>
                <div class="row schedule_cloud_hall m-0 p-1 txt-al-right" ${nodeData}>
                  <span class="txt-al-right " ${nodeData}>${hallName}</span>${streamBox}${counfFilms}
                </div>
              </div>
     
              <div class="column w-10 m-0 p-1">
                <button type="button" class = "bt_dublicate ml-auto mr-3" action="dublicate" ${nodeData}> </button>
              
              </div>
     
            </div`;
              // <button type="delete" class = "bt_delete"  ${nodeData}></button>/

    // return `<label class="reference-header schedule-row" scheduleid="${item.id}">
    //           <div class="schedule-column" scheduleid="${item.id}">${formattedTime}</div>
    //           <div class="schedule-column" scheduleid="${item.id}">${item.name}</div>
    //           <div class="schedule-column" scheduleid="${item.id}">${item.placeName}</div>
    //         </label>`;
  },

  strToDate(dtStr) {
    if(!dtStr)
      return new Date();
    // console.log(dtStr);
    let dateParts = dtStr.split("-");
    let timeParts = dateParts[2].split(" ")[1].split(":");
    dateParts[2] = dateParts[2].split(" ")[0];
    // console.log(dateParts);
    // console.log(timeParts);
    // month is 0-based, that's why we need dataParts[1] - 1
    return  new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2], timeParts[0], timeParts[1], timeParts[2]);
  },

  drawDataInContainer(enterprisesData) {
    // listPointsBody.innerHTML = `<div class="schedule-header">
    //                               <div class="schedule-column">Время</div>
    //                               <div class="schedule-column">Название </div>   
    //                               <div class="schedule-column">Локация</div>    
    //                           </div>`;

    listPointsBody.innerHTML = '';
    let maxID = 0;
    if (enterprisesData) {
      enterprisesData.forEach((item, index) => {
        if(maxID < parseInt(item.id, 10))
          maxID = parseInt(item.id, 10)
      });

      enterprisesData.forEach((item, index) => listPointsBody.insertAdjacentHTML('beforeend', this.getElement(item, index, maxID)));
    };
  },

  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  }
};
